import checkin from "./checkin"
import accidentreport from "./accidentreport"
import evaluation from "./evaluation"
import docket from "./docket"
import personaccidentreport from "./personaccidentreport"
import trainingproof from "./trainingproof"

export default {
  checkin,
  accidentreport,
  evaluation,
  docket,
  personaccidentreport,
  trainingproof
}
